
















































































  import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
  import Debug from 'debug'
  import dayjs from 'dayjs';
  import { round } from 'lodash';
  import { TranslateResult } from 'vue-i18n';
  import i18n from '@/plugins/i18n';
  import { calculateRemainingTime } from '@/app/shared/utils/date-time-utils';
  import QuestionComponent2, { Question,
                               QuestionEvaluationResult,
                               QuestionAnsweredPayload,
                               QuestionStateChangedPayload,
                               QuestionMode
                             } from '@/app/question/components/question-component2.vue';
  import { questionScoreDisplay } from '@/app/question/components/question-score-display';
  import { CurrentQuestion } from '@/app/quiz-player/api'
  import { quizScoreDisplay } from './quiz-score-display'

  const TIME_LIMIT_DANGER_FROM_SECONDS = 30;

interface NavigationState {
  isLastQuestion: boolean
  isFirstQuestion: boolean
  questionIndex: number
  questionCount: number
}

const debug = Debug('quiz-questions-component')

  @Component({
    components: {
      QuestionComponent2
    }
  })
  export default class QuizQuestionsComponentNew extends Vue {
    @Prop({ required: true })
    public currentQuestion: CurrentQuestion | null

    @Prop({ required: true })
    public mode: QuestionMode

    @Prop({ required: true })
    public navigationState: NavigationState

    @Prop({ required: true })
    public showScore: boolean

    @Prop({ required: true })
    public showTime: boolean

    @Prop({ required: true })
    public remainingTimeSeconds: number

    @Prop({ required: true })
    public nextEnabled: boolean

    @Prop({ required: true })
    public prevEnabled: boolean

    @Prop({ required: true })
    public showFinishButton: boolean

    @Prop({ required: true })
    public showBackToResultButton: boolean

    @Prop({ required: true })
    public showBottomFinishButton: boolean

    @Prop({ required: true })
    public score: { raw: number, max: number }

    @Prop({ required: true })
    public scorePrecision: number

    private get questionPointText(): TranslateResult {
      return this.t('quiz.earned_x_points', {
        score: this.currentQuestion ? questionScoreDisplay(this.currentQuestion.evaluationResult.score) : 0
      });
    }

    private get quizScoreDisplay() {
      return {
        raw: quizScoreDisplay(this.score.raw, this.scorePrecision),
        max: quizScoreDisplay(this.score.max, this.scorePrecision)
      }
    }

    private get isTimeLimitInDangerZone(): boolean {
      return this.remainingTimeSeconds <= TIME_LIMIT_DANGER_FROM_SECONDS;
    }

    private handlePrevClicked(): void {
      debug('handlePrevClicked')

      this.emitPrevNavigated()
    }

    @Emit('prev-navigated')
    private emitPrevNavigated() {
      debug('emitPrevNavigated')
    }

    private handleNextClicked(): void {
      debug('handleNextClicked')

      this.emitNextNavigated()
    }

    @Emit('next-navigated')
    private emitNextNavigated() {
      debug('emitNextNavigated')
    }

    private handleAnswerChanged(payload: QuestionAnsweredPayload): void {
      debug('handleAnswerChanged', payload)

      this.emitAnswerChanged(payload)
    }

    @Emit('answer-changed')
    private emitAnswerChanged(payload: QuestionAnsweredPayload): QuestionAnsweredPayload {
      debug('emitAnswerChanged')
      return payload;
    }

    private handleStateChanged(payload: QuestionStateChangedPayload): void {
      debug('handleStateChanged', payload)

      this.emitStateChanged(payload)
    }

    @Emit('state-changed')
    private emitStateChanged(state: QuestionStateChangedPayload): QuestionStateChangedPayload {
      debug('emitStateChanged')
      return state;
    }

    private handleQuestionEvaluated(): void {
      debug('handleQuestionEvaluated')
      this.emitEvaluated()
    }

    @Emit('evaluated')
    private emitEvaluated() {
      debug('emitEvaluated')
    }

    private handleQuestionShowSolution(): void {
      debug('handleQuestionShowSolution')
      this.emitShowSolution()
    }

    @Emit('show-solution')
    private emitShowSolution() {
      debug('emitShowSolution')
    }

    private handleQuestionReset(): void {
      debug('handleQuestionReset')
      this.emitReset()
    }

    @Emit('reset')
    private emitReset() {
      debug('emitReset')
    }

    @Emit('finished')
    private emitFinished(): void {
      debug('emitFinished')
    }

    @Emit('back-to-result')
    private emitBackToResult(): void {
      debug('emitBackToResult')
    }

    private t(key: string, params: any = {}): TranslateResult {
      return i18n.t(key, params);
    }
  }
